import { ApiProperty } from "@nestjs/swagger";

export class RmColumnsRequest{
    @ApiProperty()
    columnsId:number;
}